import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PendingSurveyDto, SurveyResponseDto, SurveyType } from '@app/data/dto';

@Injectable({ providedIn: 'root' })
export class SurveyPromptService {
  readonly manualRequested = new Subject<SurveyType>();
  readonly previewRequested = new Subject<PendingSurveyDto>();
  readonly responseSubmitted = new Subject<SurveyResponseDto>();
  openManual(surveyType: SurveyType): void { this.manualRequested.next(surveyType); }
  openPreview(pending: PendingSurveyDto): void { this.previewRequested.next(pending); }
}
